export const tableScrollClassName = "policy-table-scroll";

// A table can be a scroll container or be sized by its own content, never both: overflow on the table itself
// does nothing once its width is max-content, and display:block buys the scroll at the cost of the layout,
// since the rows then fall into an anonymous table box that shrink-wraps and ignores the width. Giving each
// table a wrapper to scroll inside keeps it a real table. The stored HTML is untouched - this is render only.
export function wrapTablesInScrollContainers(html: string): string {
    if (!html.includes("<table")) {
        return html;
    }

    const parsed = new DOMParser().parseFromString(html, "text/html");
    const tables = Array.from(parsed.body.querySelectorAll("table"));

    tables.forEach((table) => {
        // The editor writes ProseMirror's column floor into the saved markup as an inline min-width, which
        // outranks any stylesheet and pins a narrow table to its own content width. It describes the editing
        // grid, not the document, so the reading views drop it and let the width rules apply.
        table.style.removeProperty("min-width");

        const wrapper = parsed.createElement("div");
        wrapper.className = tableScrollClassName;
        table.replaceWith(wrapper);
        wrapper.appendChild(table);
    });

    return parsed.body.innerHTML;
}
